import React from 'react';
import { Input } from 'antd';
import * as CONSTANT from '../../constant';
import styles from './index.less';
import getActualShareLink from './getActualShareLink';
import CustomerContext from '../CustomerContext';

const encode = s => encodeURIComponent(s.trim().replace(/\s+/, ' '));

const mailto = (body, email, title, url) => `mailto:${encode(email)}?body=${encode(url)}%0A%0A${encode(body)}&subject=${encode(title)}`;

const EmailPane = ({
  url,
  title,
  visible,
}) => {
  const [email, setEmail] = React.useState('');
  const [emailBody, setEmailBody] = React.useState('');
  const cid = React.useContext(CustomerContext);
  const finalUrl = getActualShareLink(url, cid);

  const handleEmailChange = React.useCallback(e => setEmail(e.target.value), []);

  const handleEmailBodyChange = React.useCallback(e => setEmailBody(e.target.value), []);

  React.useEffect(() => {
    if (!visible) {
      setEmail('');
      setEmailBody('');
    }
  }, [visible]);

  return (
    <div>
      <div className={styles.row}>
        <a target="_blank" rel="noopener noreferrer" href={finalUrl}>
          {finalUrl}
        </a>
      </div>
      <div className={styles.row}>
        <Input
          className={styles.input}
          value={email}
          onChange={handleEmailChange}
          placeholder={CONSTANT.RECIPIENT}
        />
      </div>
      <div className={styles.row}>
        <Input
          className={styles.textarea}
          type="textarea"
          value={emailBody}
          onChange={handleEmailBodyChange}
          placeholder={CONSTANT.MESSAGE}
        />
      </div>
      <div className={styles.row}>
        <a href={mailto(emailBody, email, `${title}`, finalUrl)} className="button primary left">
          {CONSTANT.SEND}
        </a>
      </div>
    </div>
  );
};

export default EmailPane;
